module.exports = __webpack_public_path__ + "static/media/skipriority.83909745.svg";